import React from 'react';
import styled from 'styled-components';
import { TrevorComponent, TrevorIcon } from '@trevor/ui-components';
import Social from '@/features/publicDatasets/publicdatasets/PublicDatasetsTopPanel/Social';

const PublicDatasetsTopPanelRaw: TrevorComponent = ({ className }) => (
  <div className={className}>
    <a href="https://trevor.io">
      <TrevorIcon
        name="logo-symbol"
        height="30.32"
        width="24"
        alt="To the homepage"
        style={{ marginRight: '12px' }}
      />
    </a>
    <span>
      Explore this public dataset to find and share interesting insights 📊
    </span>
    <Social title={"Look what I've found on Trevor!"} />
  </div>
);

export const PublicDatasetsTopPanel = styled(PublicDatasetsTopPanelRaw)`
  --image-size: 48px;
  z-index: 1;
  align-items: center;
  border: 1px solid #e8e8e8;
  display: flex;
  padding: 12px 25px 12px 16px;

  & > a > img {
    height: var(--image-size);
    width: var(--image-size);
    margin-right: 27px;
  }

  div {
    margin-left: auto;
  }

  span {
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;

    display: flex;
    align-items: center;

    color: #061e2d;
  }
`;
